var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContrast = function SvgContrast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.657 15.656c-3.12 3.12-8.195 3.12-11.314 0-3.12-3.119-3.12-8.195 0-11.314l.045-.043L15.7 15.611l-.044.045m1.898.895a10.006 10.006 0 0 0 1.57-10.646 9.29 9.29 0 0 0-2.01-3.02A9.284 9.284 0 0 0 14.093.872a10.007 10.007 0 0 0-11.12 2.011l-.044.044c-3.905 3.905-3.905 10.237 0 14.142 3.905 3.905 10.237 3.905 14.142 0l.044-.045v.001c.153-.153.299-.31.44-.475",
    fill: "#000",
    fillRule: "evenodd"
  })));
};
export default SvgContrast;